<template>
  <DossierDocumentCard
    title="Licença Sanitária"
    :status-options="statusOptions"
    :multiple-status="true"
    :status-requires-validity="['possui_vigente', 'possui_provisorio']"
    :status-requires-upload="['possui_vigente', 'possui_provisorio']"
    :explainer-text="explainerText"
    :mode="mode"
    :not-applicable="false"
    :start-collapsed="startCollapsed"
    v-model="formData"
    save-endpoint="/rest-home/dossier/sanitary-license"
    upload-endpoint="/rest-home/dossier/sanitary-license/upload"
    @saved="onSaved"
    @error="onError"
  >
    <!-- Campos específicos: órgão emissor e número da licença -->
    <template #fields-before>
      <div class="dossier-module__fields">
        <div class="dossier-module__field-group">
          <label class="dossier-module__label">Órgão emissor</label>
          <v-text-field
            v-if="!isViewMode"
            v-model="formData.issuing_body"
            dense
            outlined
            hide-details
            placeholder="Ex: Vigilância Sanitária Municipal"
            class="dossier-module__input"
          />
          <span v-else class="dossier-module__view-value">{{
            formData.issuing_body || "—"
          }}</span>
        </div>

        <div
          class="dossier-module__field-group dossier-module__field-group--small"
        >
          <label class="dossier-module__label">Número da licença</label>
          <v-text-field
            v-if="!isViewMode"
            v-model="formData.license_number"
            dense
            outlined
            hide-details
            placeholder="Número ou protocolo"
            class="dossier-module__input"
          />
          <span v-else class="dossier-module__view-value">{{
            formData.license_number || "—"
          }}</span>
        </div>

        <!-- Classificação de risco (campo específico da Vigilância Sanitária) -->
        <div
          class="dossier-module__field-group dossier-module__field-group--small"
        >
          <label class="dossier-module__label">Grau de risco</label>
          <v-select
            v-if="!isViewMode"
            v-model="formData.risk_level"
            :items="riskLevels"
            dense
            outlined
            hide-details
            placeholder="Selecione"
            class="dossier-module__input"
          />
          <span v-else class="dossier-module__view-value">{{
            formData.risk_level || "—"
          }}</span>
        </div>
      </div>
    </template>
  </DossierDocumentCard>
</template>

<script>
import DossierDocumentCard from "../dossier/DossierDocumentCard.vue";

const EXPLAINER_TEXT = `
  A Licença Sanitária é emitida pela Vigilância Sanitária (municipal ou estadual)
  e autoriza o funcionamento da ILPI do ponto de vista sanitário.<br><br>
  É obrigatória para estabelecimentos de saúde e de longa permanência,
  devendo ser renovada conforme periodicidade definida pelo órgão emissor.<br><br>
  O grau de risco é classificado pela Vigilância Sanitária e consta no próprio
  documento da licença.<br><br>
  O Sistema Clin não valida o conteúdo do documento, apenas registra sua
  existência para fins de organização e apresentação à fiscalização.
`;

export default {
  name: "DossierSanitaryLicense",
  components: { DossierDocumentCard },
  props: {
    mode: {
      type: String,
      default: "edit",
      validator: (v) => ["edit", "view"].includes(v),
    },
    initialData: { type: Object, default: () => ({}) },
    startCollapsed: { type: Boolean, default: false },
  },
  data() {
    return {
      explainerText: EXPLAINER_TEXT,
      statusOptions: [
        { value: "possui_vigente", label: "Possui licença vigente" },
        { value: "possui_provisorio", label: "Possui licença provisória" },
        { value: "em_renovacao", label: "Em processo de renovação" },
        { value: "nao_possui", label: "Não possui (pendente)" },
      ],
      riskLevels: ["Grau 1", "Grau 2", "Grau 3", "Grau 4"],
      formData: {
        issuing_body: "",
        license_number: "",
        risk_level: null,
        status: [],
        validity_date: null,
        file_url: null,
        file_name: null,
        observations: "",
        ...this.flattenInitialData(),
      },
    };
  },
  computed: {
    isViewMode() {
      return this.mode === "view";
    },
  },
  watch: {
    initialData: {
      deep: true,
      handler() {
        Object.assign(this.formData, this.flattenInitialData());
      },
    },
  },
  methods: {
    flattenInitialData() {
      const d = this.initialData || {};
      return {
        issuing_body: d.issuing_body || "",
        license_number: d.license_number || "",
        risk_level: d.risk_level || null,
        status: d.status || [],
        validity_date: d.validity_date || null,
        file_url: d.file_url || null,
        file_name: d.file_name || null,
        observations: d.observations || "",
      };
    },
    onSaved(data) {
      this.$emit("saved", { module: "sanitary_license", data });
    },
    onError(errors) {
      this.$emit("error", { module: "sanitary_license", errors });
    },
  },
};
</script>